import React from 'react';
import { formatTimestamp } from '../../lib/utils';
import styles from './Devices.module.scss';

const OFFLINE_TROUBLESHOOTING_URL =
  'https://support.fitracking.com/hc/en-us/articles/360033210214-Offline-Fi-Device-Troubleshooting';

interface DeviceStatusCellProps {
  isOnline: boolean;
  lastSeen: string | null | undefined;
}

/**
 * Online/offline status with a last-seen timestamp. Offline state wraps the
 * cell in a link to the troubleshooting article — used in every device row.
 */
export default function DeviceStatusCell({ isOnline, lastSeen }: DeviceStatusCellProps) {
  if (isOnline) {
    return (
      <>
        <div className={styles.statusCell}>
          <span className={`${styles.statusDot} ${styles.statusOnline}`} />
          Online
        </div>
        <div className={styles.lastSeen}>Now</div>
      </>
    );
  }
  return (
    <a
      href={OFFLINE_TROUBLESHOOTING_URL}
      target="_blank"
      rel="noopener noreferrer"
      title="Troubleshooting: Offline Fi Device"
      className={styles.offlineLink}
    >
      <div className={styles.statusCell}>
        <span className={`${styles.statusDot} ${styles.statusOffline}`} />
        Offline
      </div>
      <div className={styles.lastSeen}>{formatTimestamp(lastSeen)}</div>
    </a>
  );
}
